import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { WalletProvider } from "@/contexts/WalletContext";
import { Toaster } from "sonner";
import Layout from "@/components/layout/Layout";
import ExplorerHome from "@/pages/ExplorerHome";
import BlockDetail from "@/pages/BlockDetail";
import TxDetail from "@/pages/TxDetail";
import AddressPage from "@/pages/AddressPage";
import DocsPage from "@/pages/DocsPage";
import FaucetPage from "@/pages/FaucetPage";
import SwapPage from "@/pages/SwapPage";
import BuyPage from "@/pages/BuyPage";
import SellPage from "@/pages/SellPage";
import StatusPage from "@/pages/StatusPage";
import QuickstartPage from "@/pages/QuickstartPage";
import MyTokensPage from "@/pages/MyTokensPage";
import AccountPage from "@/pages/AccountPage";
import ReceiptPage from "@/pages/ReceiptPage";
import { SplashIntro } from "@/components/layout/SplashIntro";
import FbtcPage from "@/pages/FbtcPage";
import PricesPage from "@/pages/PricesPage";
import LiquidityPage from "@/pages/LiquidityPage";
import DexPage from "@/pages/DexPage";
import LegalPage, { LEGAL_ROUTES } from "@/pages/LegalPage";
import AdminPage from "@/pages/AdminPage";

const TOAST_OPTIONS = { style: { background: "#0A0A0A", border: "1px solid #2A2411", color: "#fff" } };

function App() {
  return (
    <WalletProvider>
      <SplashIntro />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<ExplorerHome />} />
            <Route path="/block/:number" element={<BlockDetail />} />
            <Route path="/tx/:hash" element={<TxDetail />} />
            <Route path="/receipt/:hash" element={<ReceiptPage />} />
            <Route path="/address/:address" element={<AddressPage />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/faucet" element={<FaucetPage />} />
            <Route path="/swap" element={<SwapPage />} />
            <Route path="/buy" element={<BuyPage />} />
            <Route path="/sell" element={<SellPage />} />
            <Route path="/status" element={<StatusPage />} />
            <Route path="/fbtc" element={<FbtcPage />} />
            <Route path="/prices" element={<PricesPage />} />
            <Route path="/liquidity" element={<LiquidityPage />} />
            <Route path="/dex" element={<DexPage />} />
            {Object.entries(LEGAL_ROUTES).map(([path, page]) => <Route key={path} path={path} element={<LegalPage key={page} page={page} />} />)}
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/get-started" element={<QuickstartPage />} />
            <Route path="/my-tokens" element={<MyTokensPage />} />
            <Route path="/account" element={<AccountPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={TOAST_OPTIONS}
      />
    </WalletProvider>
  );
}

export default App;
